import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DepartmentDTO from "../../shared/dtos/departmentDTO";
import { getDepartmentsByAdminApi } from "../../services/departmentApi";

interface InitialState {
  value: Array<DepartmentDTO>;
  adminId: number | null;
  loading: boolean;
}

const initialState: InitialState = {
  value: [] as Array<DepartmentDTO>,
  adminId: null,
  loading: false,
};

export const departmentsByAdminAsync = createAsyncThunk(
  "departmentsByAdmin/",
  async (adminId?: number) => {
    const response = await getDepartmentsByAdminApi(adminId);
    return response;
  }
);

const departmentsByAdminSlice = createSlice({
  name: "departmentsByAdmin",
  initialState,
  reducers: {
    setAdminId: (state, actions) => {
      state.adminId = actions.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(departmentsByAdminAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(departmentsByAdminAsync.fulfilled, (state, action) => {
        state.value = action.payload;
        state.loading = false;
      })
      .addCase(departmentsByAdminAsync.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { setAdminId } =
  departmentsByAdminSlice.actions;

export default departmentsByAdminSlice.reducer;
